<template>
  <AppModal v-if="isSetuping" :mode="mode" title="Setup MFA" @close="close">
    <template #body>
      <div
        class="overflow-hidden rounded-lg border"
        :class="[mode === 'dark' ? 'border-dark-border' : 'border-border-10']"
      >
        <div
          class="relative mx-auto flex w-[400px] items-center justify-between gap-2 py-4"
        >
          <span
            class="relative z-10 flex h-[30px] w-[30px] items-center justify-center rounded-full text-sm font-medium"
            :class="[
              step === 'phone' || step === 'verify' || step === 'success'
                ? 'bg-primary-100 !font-semibold text-white-100'
                : mode === 'dark'
                  ? 'bg-dark-border text-white-100'
                  : 'bg-[#e6e6e7] text-black-100',
            ]"
            >1</span
          >
          <span
            class="relative z-10 flex h-[30px] w-[30px] items-center justify-center rounded-full text-sm font-medium"
            :class="[
              step === 'verify' || step === 'success'
                ? 'bg-primary-100 !font-semibold text-white-100'
                : mode === 'dark'
                  ? 'bg-dark-border text-white-100'
                  : 'bg-[#e6e6e7] text-black-100',
            ]"
            >2</span
          >
          <span
            class="relative z-10 flex h-[30px] w-[30px] items-center justify-center rounded-full text-sm font-medium"
            :class="[
              step === 'success'
                ? 'bg-primary-100 !font-semibold text-white-100'
                : mode === 'dark'
                  ? 'bg-dark-border text-white-100'
                  : 'bg-[#e6e6e7] text-black-100',
            ]"
            >3</span
          >
          <div
            class="absolute h-[5px] w-full overflow-hidden"
            :class="[mode === 'dark' ? 'bg-dark-border' : 'bg-border-10']"
          >
            <div
              class="absolute left-0 top-0 h-full w-full transform bg-primary-100 transition-transform duration-200"
              :class="[
                step === 'phone'
                  ? '-translate-x-full'
                  : step === 'verify'
                    ? '-translate-x-1/2'
                    : step === 'success'
                      ? 'translate-x-0'
                      : '-translate-x-full',
              ]"
            ></div>
          </div>
        </div>
        <div class="mt-2 px-4 pb-4">
          <div v-if="step === 'phone'" class="grid gap-4">
            <span class="block text-center text-[18px] font-semibold"
              >Send Code</span
            >
            <AppInput
              :mode="mode"
              type="tel"
              placeholder="Enter phone number"
              v-model="phoneNumber"
              :hasLabel="false"
            />
            <AppSelect :mode="mode" v-model="channel" :hasLabel="false">
              <template #options>
                <option value="sms">SMS</option>
                <option value="call">Voice Call</option>
                <option value="whatsapp">WhatsApp</option>
              </template>
            </AppSelect>
            <AppButton
              title="Send Code"
              @action="sendCode"
              :isDisabled="!phoneNumber"
            />
          </div>
          <div v-if="step === 'verify'" class="grid gap-4">
            <span class="block text-center text-[18px] font-semibold"
              >Verify</span
            >
            <AppInput
              :mode="mode"
              placeholder="Enter verification code"
              v-model="verificationCode"
              maxlength="6"
              :hasLabel="false"
            />
            <div class="grid grid-cols-2 gap-4">
              <AppButton
                title="Verify"
                @action="verifyCode"
                :isDisabled="!verificationCode"
              />
              <AppButton
                title="Resend Code"
                @action="resendCode"
                type="secondary"
              />
            </div>
          </div>
          <div v-if="step === 'success'">
            <div
              class="flex flex-col items-center justify-center gap-[10px] text-center"
            >
              <span
                class="flex h-[60px] w-[60px] items-center justify-center rounded-full bg-success-100 bg-opacity-10 text-success-100"
              >
                <CheckCheck :size="24" :stroke-width="1.75" />
              </span>
              <span class="text-[18px] font-semibold"
                >MFA enabled successfully</span
              >
            </div>
          </div>
        </div>
      </div>
    </template>
  </AppModal>
</template>

<script>
import { useToastStore } from "@S/toast";
import { CheckCheck } from "lucide-vue-next";
import AppInput from "@C/Form/AppInput.vue";
import AppSelect from "@C/Form/AppSelect.vue";
import AppModal from "@C/Common/AppModal.vue";
import AppButton from "@C/Common/AppButton.vue";

export default {
  name: "SetupMfa",
  props: {
    mode: String,
    isSetuping: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const toastStore = useToastStore();
    return {
      toastStore,
    };
  },
  components: {
    AppModal,
    AppInput,
    AppSelect,
    CheckCheck,
    AppButton,
  },
  data() {
    return {
      step: "phone",
      phoneNumber: "",
      channel: "sms",
      verificationCode: "",
    };
  },
  methods: {
    close() {
      this.$emit("closeSetupMfa");
      this.step = "phone";
      this.phoneNumber = "";
      this.verificationCode = "";
      this.channel = "sms";
    },
    sendCode() {
      const phonePattern = /^\+?[1-9]\d{1,14}$/;
      const isValidPhoneNumber = phonePattern.test(this.phoneNumber);
      if (!isValidPhoneNumber) {
        this.toastStore.show("Invalid phone number", "error");
        return;
      }
      this.step = "verify";
    },
    verifyCode() {
      this.step = "success";
    },
  },
  watch: {
    step(val) {
      if (val === "success") {
        setTimeout(() => {
          this.close();
        }, 2000);
      }
    },
  },
};
</script>
